export default {
  views: {
    header: {
      title: "TokenPocket",
      text: "A multi-chain digital wallet, portal to DApp, DeFi and NFT"
    },
    text: "Powerful and Simple to enioy",
    download: "Android",
    appStore: "App Store",
    powerful: "Powerful",
    store: "Store",
    multiChain: "Multi-Chain",
    enterpriseEdition: "Enterprise Edition",
    course: "Enterprise Edition Installation tutorial",
    version: "Version",
    appCourse: "Course",
    commonProblem: "Common Download Problem",
    beta: "Beta",
    recommend: "REC",
    getItOn: "GET IT ON",
    desc_1:
      "Tips: TokenPocket has restricted Chinese users to access and use third-party financial applications!",
    desc_2: "Learn more",
    desc_3:
      "Download the app from the official website and check its SSL certification.",
    desc_4:
      "Protect recovery phrase and private key from leaking, Don't trust unknown call.",
    desc_5: "Learn about recent scams!",
    verifyText: "Latest Android Version:",
    verifyText1: "How to verify an app's security >",
    verifyText2: "Latest Version",
    verifyText3: "Latest Google Play Version:"
  },
  common: {
    download: "Download"
  },
  ios: {
    desc_1: "A multi-chain crypto wallet, portal to DeFi, DApp and NFT",
    desc_2:
      "Supports 2200+ Dapps on EOS, ETH, TRON, and IOST with a built-in Dapp Store.",
    text_title_1: "What's TestFlight? ",
    text_text_1_1:
      "TestFlight is an online service for helping developers test beta versions of their apps.",
    text_text_1_2:
      "The TokenPocket Pro version on TestFlight has a built-in DApp Store compared to the AppStore version.",
    text_title_2: "Get start with TestFlight",
    text_text_2_1: "1. Tap on the TestFlight button above.",
    text_text_2_2: "2. Install TestFlight.",
    text_text_2_3:
      "3. Tap View in TestFlight or Start Testing; or tap Install or Update for the app you want to test.",
    text_title_3: "Learn more about TestFlight",
    text_text_3: "* Testing Apps with TestFlight"
  }
};
